import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import ReleaseCard from "@/components/ReleaseCard";
import { RELEASES } from "@/content";

export default function Listen() {
  return (
    <section id="listen" data-testid="listen-section" className="py-24 md:py-36 px-6 md:px-12 bg-sand/40">
      <div className="max-w-7xl mx-auto">
        <SectionHeading number="04" title="Listen" testId="listen-heading" />

        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {RELEASES.map((release, i) => (
            <Reveal key={release.title} delay={0.08 + i * 0.05}>
              <ReleaseCard release={release} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
